import React, { useEffect } from "react";
import "./App.css";
import { Router, Switch, withRouter } from "react-router-dom";
import { createBrowserHistory } from "history";

import AppProvider from "./AppProvider";
import { UnauthorizedRoute, AuthorizedRoute, routes } from "./routes";
import Login from "./Layouts/Login";
import OrderCreation from "./Layouts/OrderCreation";
import OrdersList from "./Layouts/OrdersList";
import ProductList from "./Layouts/ProductList";
import ProductDetail from "./Layouts/ProductDetail";
import Topbar from "./Layouts/Topbar";
import Toasts from "./Layouts/Toasts";
import SyncModal from "./Layouts/SyncModal";

import CurrentOrder from "./Layouts/CurrentOrder";
import ProductsImagesPreload from "./Layouts/ProductsImagesPreload";
import OrderUpdate from "./Layouts/OrderUpdate";
import LandingPage from "./Layouts/LandingPage";
import LowaCustomerSelect from "./Layouts/LowaCustomerSelect";
import OrderConfirmation from "./Layouts/OrderConfirmation";
import Salesfive from "./Layouts/Salesfive";

import { SpinnerIcon, CenteredWidthLayout } from "./Components";

import AppContext from "./AppContext";
import {
  isAuthenticated,
  isStartingUp,
  getPreloadingImagesEnable,
} from "./selectors";
import { PreloadImageText } from "./Layouts/PreloadImageText";

const LOGGED_OUT_ROUTE = routes.login;

const ScrollToTop = withRouter(({ children, location: { pathname } }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return children || null;
});

const history = createBrowserHistory();

const AppEntry = () => (
  <div className="App">
    <SyncModal />
    <Toasts />
    <Router history={history}>
      <ScrollToTop />
      <AppContext.Consumer>
        {(context) => {
          if (isStartingUp(context)) {
            return (
              <CenteredWidthLayout>
                <SpinnerIcon />
              </CenteredWidthLayout>
            );
          }

          const lowa = context.state.lowa;
          let afterLoginScreen = routes.landingPage;
          if (lowa) {
            afterLoginScreen = routes.lowaCustomerSelect;
          }

          return (
            <>
              <div className="margin-10p">
                {isAuthenticated(context) ? <Topbar /> : null}
                {isAuthenticated(context) &&
                !!getPreloadingImagesEnable(context) ? (
                  <>
                    <ProductsImagesPreload />
                    <PreloadImageText />
                  </>
                ) : null}
              </div>
              <Switch>
                <UnauthorizedRoute
                  authenticated={isAuthenticated(context)}
                  exact
                  path={routes.login}
                  component={Login}
                  redirectTo={afterLoginScreen}
                />
                <AuthorizedRoute
                  redirectTo={LOGGED_OUT_ROUTE}
                  authenticated={isAuthenticated(context)}
                  exact
                  path={routes.lowaCustomerSelect}
                  component={LowaCustomerSelect}
                />
                <AuthorizedRoute
                  redirectTo={LOGGED_OUT_ROUTE}
                  authenticated={isAuthenticated(context)}
                  exact
                  path={routes.landingPage}
                  component={LandingPage}
                />
                <AuthorizedRoute
                  redirectTo={LOGGED_OUT_ROUTE}
                  authenticated={isAuthenticated(context)}
                  exact
                  path={routes.orderCustomerSelection}
                  component={OrderCreation}
                />
                <AuthorizedRoute
                  redirectTo={LOGGED_OUT_ROUTE}
                  authenticated={isAuthenticated(context)}
                  exact
                  path={routes.productList}
                  component={ProductList}
                />
                <AuthorizedRoute
                  redirectTo={LOGGED_OUT_ROUTE}
                  authenticated={isAuthenticated(context)}
                  exact
                  path="/productDetail/:id"
                  component={ProductDetail}
                />
                <AuthorizedRoute
                  redirectTo={LOGGED_OUT_ROUTE}
                  authenticated={isAuthenticated(context)}
                  exact
                  path={routes.orderList}
                  component={OrdersList}
                />
                <AuthorizedRoute
                  redirectTo={LOGGED_OUT_ROUTE}
                  authenticated={isAuthenticated(context)}
                  exact
                  path={routes.currentOrder}
                  component={CurrentOrder}
                />
                <AuthorizedRoute
                  redirectTo={LOGGED_OUT_ROUTE}
                  authenticated={isAuthenticated(context)}
                  exact
                  path="/orderUpdate/:id"
                  component={OrderUpdate}
                />
                <AuthorizedRoute
                  redirectTo={LOGGED_OUT_ROUTE}
                  authenticated={isAuthenticated(context)}
                  exact
                  path={routes.orderConfirmation}
                  component={OrderConfirmation}
                />
              </Switch>
              <Salesfive />
            </>
          );
        }}
      </AppContext.Consumer>
    </Router>
  </div>
);

function App() {
  return (
    <AppProvider>
      <AppEntry />
    </AppProvider>
  );
}

//export default Sentry.withProfiler(App);
export default App;
